import React, { createContext, useContext, useState, useCallback } from "react";
import ComplaintModal from "../components/ComplaintModal";

// Permite abrir o formulário de reclamação como POPUP sobre a página atual (sem navegar / sem ter que voltar).
// A página /denunciar continua existindo para links diretos, SEO, deep-links (?tipo=, ?empresa=) e o chat.
const Ctx = createContext({ openComplaint: () => {}, closeComplaint: () => {} });
export const useComplaintModal = () => useContext(Ctx);

export function ComplaintModalProvider({ children }) {
  const [state, setState] = useState({ open: false, initial: null });
  // initial: { tipo, empresa, vaga, empresaId } — pré-preenche o form (ex.: card de categoria, página da empresa).
  const openComplaint = useCallback((initial = null) => setState({ open: true, initial }), []);
  const closeComplaint = useCallback(() => setState((s) => ({ ...s, open: false })), []);

  return (
    <Ctx.Provider value={{ openComplaint, closeComplaint }}>
      {children}
      {state.open && <ComplaintModal initial={state.initial} onClose={closeComplaint} />}
    </Ctx.Provider>
  );
}
